(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('CollectionIbqDialogController', CollectionIbqDialogController);

    CollectionIbqDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Collection', 'Disc'];

    function CollectionIbqDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Collection, Disc) {
        var vm = this;

        vm.collection = entity;
        vm.clear = clear;
        vm.save = save;
        vm.discs = Disc.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.collection.id !== null) {
                Collection.update(vm.collection, onSaveSuccess, onSaveError);
            } else {
                Collection.save(vm.collection, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('virtuallibraryApp:collectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
